'use client';

import { useRouter } from 'next/navigation'
import { getTimestamp } from "@/app/components/helpers";
import { usePatients } from "@/app/contexts/PatientsContext";
import { resolveRoute } from '@/app/helpers';
import { AppRoutes } from '@/app/routes';
import { PatientDTO } from '@/dto/patient.dto';
import Loading from '@/app/components/Loading';
import SearchBar from '@/app/components/SearchBar';

export default function PatientsList() {
    const {
        patients,
        isLoading,
        isNextPage,
        isNextPageLoading,
        loadNextPage,
        searchByName
     } = usePatients();
    const router = useRouter();

    const onPatientClick = (patientId: PatientDTO['id']) => {
        router.push(resolveRoute(AppRoutes.PatientDetails, patientId))
    };

    return (
        <div className="p-6">
            <div className="w-full flex justify-between items-center mb-3 mt-1">
                <h2 className="text-xl font-bold">Patients List</h2>
                <SearchBar placeholder="Search by name" searchHandler={searchByName} />
            </div>
            {isLoading && <Loading />}

            {patients?.length > 0 && (
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
                        <thead className="bg-gray-200">
                            <tr>
                                <th className="p-3 text-left">#</th>
                                {/* <th className="p-3 text-left">Patient ID</th> */}
                                <th className="p-3 text-left">First Name</th>
                                <th className="p-3 text-left">Last Name</th>
                                <th className="p-3 text-left">Sex</th>
                                <th className="p-3 text-left">Phone</th>
                                <th className="p-3 text-left">Last Updated On</th>
                            </tr>
                        </thead>
                        <tbody>
                            {patients?.map((patient, index) => (
                                <tr
                                    key={patient.id}
                                    onClick={() => onPatientClick(patient.id)}
                                    className="border-b cursor-pointer hover:bg-gray-100 transition-colors"
                                >
                                    <td className="p-3">{index + 1}</td>
                                    {/* <td className="p-3">{patient.id}</td> */}
                                    <td className="p-3">{patient.officialName.firstname}</td>
                                    <td className="p-3">{patient.officialName.lastname}</td>
                                    <td className="p-3">{patient.gender}</td>
                                    <td className="p-3">{patient.phone}</td>
                                    <td className="p-3">{getTimestamp(patient.lastUpdated)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    { isNextPage && (
                    <div className="flex justify-center mt-4">
                        <button
                            type="button"
                            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none"
                            onClick={() => loadNextPage()}
                        >{isNextPageLoading ? 'Loading...' : 'Load More'}</button>
                    </div>
                    )}
                </div>
            ) }
        </div>
    );
}
